var map = {
	"./Executive_Mang/clint1.png": "9ff1",
	"./Executive_Mang/clint10.png": "e2d7",
	"./Executive_Mang/clint11.png": "3556",
	"./Executive_Mang/clint12.png": "5fae",
	"./Executive_Mang/clint2.png": "a6a1",
	"./Executive_Mang/clint3.png": "aad2",
	"./Executive_Mang/clint4.png": "6509",
	"./Executive_Mang/clint5.png": "7cf6",
	"./Executive_Mang/clint6.png": "3132",
	"./Executive_Mang/clint7.png": "89f2",
	"./Executive_Mang/clint8.png": "f4ef",
	"./Executive_Mang/clint9.png": "5617",
	"./Gen-Z.jpeg": "60db",
	"./Home/SVG/landing-graphic-1.svg": "9f43",
	"./Home/SVG/landing-graphic-2.svg": "d840",
	"./Home/SVG/landing-graphic-3.svg": "180a",
	"./Home/SVG/logo.svg": "dbbb",
	"./Home/landing.jpg": "868a",
	"./Home/landing.png": "889a",
	"./New folder/01.svg": "d913",
	"./New folder/02.svg": "8d90",
	"./New folder/03.svg": "8ad3",
	"./New folder/04.svg": "d8ca",
	"./New folder/05.svg": "5ac9",
	"./New folder/06.svg": "d85a",
	"./New folder/07.svg": "7fb5",
	"./New folder/08.svg": "2db5",
	"./New folder/09.svg": "17d4",
	"./RM2.jpeg": "5423",
	"./RM3.jpeg": "56ea",
	"./Rectangle 8.png": "07d8",
	"./WE-ABLE-Comp.png": "b8fb",
	"./adopting-IN.png": "1682",
	"./backgrounds/certificate.svg": "5bbb",
	"./backgrounds/commercial_and_customer_experience.png": "4071",
	"./backgrounds/year-in-review.png": "5501",
	"./banners/BOD-message-banner-responsive.jpg": "77a6",
	"./banners/BOD-message-banner.jpg": "1d0f",
	"./banners/Group 195.png": "f75a",
	"./banners/board-of-directors.png": "3296",
	"./banners/diversity-inclusion.jpg": "566c",
	"./banners/evaluation-banner.jpg": "4da4",
	"./banners/gov-intro-rules-bg.png": "5190",
	"./banners/governance-banner2.png": "5a16",
	"./banners/governance-banner3.png": "2772",
	"./banners/governance-banner6.png": "ac5d",
	"./banners/governance-banner7.png": "d114",
	"./banners/governance-bannner4.png": "3f5f",
	"./banners/governance-bannner5.png": "edc8",
	"./banners/governance-bannner8.png": "571b",
	"./banners/governance.png": "2cc9",
	"./banners/governance_intro.png": "9f32",
	"./banners/keymilestone-banner.png": "4e8c",
	"./banners/kpis-banner-responsive.png": "c936",
	"./banners/kpis-banner.png": "306a",
	"./banners/main-content-mob.jpg": "ddbf",
	"./banners/managment-banner.jpg": "a3aa",
	"./banners/regulatory-four.png": "e0ee",
	"./banners/regulatory-one.png": "a7c0",
	"./banners/regulatory-three.png": "404f",
	"./banners/regulatory-two.png": "1b05",
	"./banners/strategy-banner.jpg": "d092",
	"./banners/strategy-main-banner.png": "8d95",
	"./banners/strategy-main-banner1.png": "9862",
	"./banners/strategy-slider-3.png": "31fb",
	"./banners/tableContent-banner.png": "9b8b",
	"./banners/technology1-ar.png": "d0e5",
	"./banners/technology1.png": "367a",
	"./banners/technology3.png": "f050",
	"./banners/worldofzain-continent.jpg": "0d13",
	"./banners/worldofzain.jpg": "4260",
	"./banners/year-in-glance-banner.png": "e32d",
	"./big-flags/bahrain.png": "8e42",
	"./big-flags/iraq.png": "9017",
	"./big-flags/jordan.png": "022c",
	"./big-flags/kuwait.png": "fb7a",
	"./big-flags/saudia.png": "2d78",
	"./big-flags/south-sudan.png": "3075",
	"./big-flags/sudan.png": "8794",
	"./board-directors/1.jpg": "c75c",
	"./board-directors/2.jpg": "ac40",
	"./board-directors/2.png": "5783",
	"./board-directors/3.jpg": "0c33",
	"./board-directors/4.png": "0bc7",
	"./board-directors/5.png": "d692",
	"./board-directors/Abdulrahman_Mohammed.png": "2ba2",
	"./board-directors/Ahmed_Tahous.png": "afb76",
	"./board-directors/Aladdin_Baitfadhil.png": "a197",
	"./board-directors/Atif[1].jpg": "ae13",
	"./board-directors/Atif_Said.png": "0720",
	"./board-directors/Bader_Nasser.png": "7bc2",
	"./board-directors/Nasser_bin_Suleiman.png": "3f0e",
	"./board-directors/New folder/Abdulrahman_Mohammed.png": "add5",
	"./board-directors/New folder/Aladdin_Baitfadhil.png": "0b3c",
	"./board-directors/New folder/Atif_Said_Rashid.png": "698a",
	"./board-directors/New folder/Bader_Nasser.png": "a867",
	"./board-directors/New folder/Nasser_bin_Suleiman.png": "1eab",
	"./board-directors/New folder/Talal_Said.png": "0d4b",
	"./board-directors/New folder/Yousef_Khaled.png": "11e9",
	"./board-directors/New folder/Zaki_Hilal_Saud.png": "cd42",
	"./board-directors/Talal_Said.png": "2a74",
	"./board-directors/Yousef_Khaled.png": "8861",
	"./board-directors/Zaki_Hilal_Saud.png": "800d",
	"./board-directors/background.png": "f94d",
	"./business-operations/coverage.svg": "3d3b",
	"./business-operations/currency.svg": "fab9",
	"./business-operations/customers.svg": "0cfb2",
	"./business-operations/ebitda.svg": "5070",
	"./business-operations/flag.svg": "147a",
	"./business-operations/market-share.svg": "025d",
	"./business-operations/ownership.svg": "ab66",
	"./business-operations/paneration.svg": "747f",
	"./business-operations/revenue.svg": "e74b",
	"./business-operations/towers.svg": "6901",
	"./business-operations/wifi.svg": "5289",
	"./circle.svg": "3e62",
	"./close_icon.png": "4ed6",
	"./code-2021-7-2.png": "b577",
	"./code-2021-7.png": "5d2e",
	"./corporate-sustainability/CDP.png": "8c3f",
	"./corporate-sustainability/FTSE.png": "4ef3",
	"./corporate-sustainability/GRI-logo.png": "df05",
	"./corporate-sustainability/Iraq-img.png": "1fd5",
	"./corporate-sustainability/MSCI.png": "30ff",
	"./corporate-sustainability/QRcode.png": "2030",
	"./corporate-sustainability/SASB.png": "6bd2",
	"./corporate-sustainability/SDG-goals.png": "065b",
	"./corporate-sustainability/TCFD.png": "753d",
	"./corporate-sustainability/United-Nation.png": "03d5",
	"./corporate-sustainability/baharain-img.png": "27e5",
	"./corporate-sustainability/bg1.png": "df80",
	"./corporate-sustainability/bg2.png": "d5bb",
	"./corporate-sustainability/bg4.png": "8f48",
	"./corporate-sustainability/book.png": "0c96",
	"./corporate-sustainability/generationyouth-banner.jpg": "8b1e",
	"./corporate-sustainability/generationyouth-banner2.jpg": "2802",
	"./corporate-sustainability/globe.png": "c93d",
	"./corporate-sustainability/inclusivity.jpg": "2885",
	"./corporate-sustainability/jordan.png": "380f",
	"./corporate-sustainability/kuwait.png": "3b67",
	"./corporate-sustainability/saudia-arabia.png": "367c",
	"./corporate-sustainability/south-sudan.png": "68cb",
	"./corporate-sustainability/sudan.png": "5f93",
	"./corporate-sustainability/svg/Vision.svg": "f5b4",
	"./corporate-sustainability/svg/bahrain.svg": "d717",
	"./corporate-sustainability/svg/business.svg": "ad86",
	"./corporate-sustainability/svg/climate.svg": "77c8",
	"./corporate-sustainability/svg/customer.svg": "6784",
	"./corporate-sustainability/svg/generaion.svg": "1748",
	"./corporate-sustainability/svg/graduate.svg": "0a9b",
	"./corporate-sustainability/svg/inclusivity.svg": "d381",
	"./corporate-sustainability/svg/iraq.svg": "75ce",
	"./corporate-sustainability/svg/jordan.svg": "84b5",
	"./corporate-sustainability/svg/key.svg": "2f35",
	"./corporate-sustainability/svg/kuwait.svg": "68d7",
	"./corporate-sustainability/svg/mission.svg": "0994",
	"./corporate-sustainability/svg/ngo.svg": "d69d",
	"./corporate-sustainability/svg/online-learning.svg": "09f3",
	"./corporate-sustainability/svg/saudi-arabia.svg": "ca26",
	"./corporate-sustainability/svg/social-chart.svg": "4f18",
	"./corporate-sustainability/svg/social-chart_ar.svg": "b4e4",
	"./corporate-sustainability/svg/socialmedia.svg": "ecd3",
	"./corporate-sustainability/svg/south-sudan.svg": "b8c1",
	"./corporate-sustainability/svg/sudan.svg": "4432",
	"./corporate-sustainability/svg/unicef.svg": "d235",
	"./country/MaskGroup1.png": "bd55",
	"./country/MaskGroup1.svg": "2c0d",
	"./country/MaskGroup2.svg": "254a",
	"./country/MaskGroup5.svg": "ec10",
	"./country/MaskGroup6.svg": "8a8e",
	"./country_flags/bharain.png": "1667",
	"./country_flags/iraq.png": "070e",
	"./country_flags/jordan.png": "cbd1",
	"./country_flags/kuwait.png": "febd",
	"./country_flags/oman.png": "e36f",
	"./country_flags/saudia.png": "411e",
	"./country_flags/sudan.png": "6551",
	"./custumer/AWARDS.png": "f941",
	"./custumer/DJI_0219-Edit.png": "93a3",
	"./custumer/DSC07859-Edit-.png": "d51d",
	"./custumer/EdTGIudWoAExcWU.png": "fe39",
	"./custumer/NXN1.png": "1f35",
	"./custumer/NXN2.png": "5689",
	"./custumer/NXN3.png": "53a9",
	"./custumer/NXN4.png": "daf9",
	"./custumer/SmartphonesWife2.png": "d45d",
	"./custumer/Zain_B2B_Classera-2.png": "0ff0",
	"./custumer/Zain_B2B_Classera.png": "f087",
	"./custumer/baharain-1.png": "f6e0",
	"./custumer/baharain-2.png": "180e",
	"./custumer/baharain-3.png": "e87e",
	"./custumer/boardImage.png": "cf62",
	"./custumer/card3.png": "6ff5",
	"./custumer/card4.png": "e4bb",
	"./custumer/card5.png": "f870",
	"./custumer/card6.png": "4a0d",
	"./custumer/dataPark1.png": "4283",
	"./custumer/dataPark2.png": "fce9",
	"./custumer/dataPark3.png": "2c97",
	"./custumer/dataPark4.png": "9f7b",
	"./custumer/dataPark5.png": "7cd5",
	"./custumer/digitalTransformation.png": "512a",
	"./custumer/digitalized-1.png": "350c",
	"./custumer/digitalized-2.png": "32c8",
	"./custumer/digitalized-3.png": "8302",
	"./custumer/iraq-1.png": "e765",
	"./custumer/iraq-2.png": "9f8d",
	"./custumer/iraq-3.png": "830b",
	"./custumer/iraq-4.png": "9fae",
	"./custumer/jordan-1.png": "a16a",
	"./custumer/jordan-2.png": "d64a",
	"./custumer/saudia-1.png": "afda",
	"./custumer/saudia-2.png": "c5bc",
	"./custumer/saudia-3.png": "b31c",
	"./custumer/saudia-4.png": "9534",
	"./custumer/saudia-5.png": "02ed",
	"./custumer/saudia-6.png": "0116",
	"./custumer/saudia-7.png": "daca",
	"./custumer/saudia-8.png": "f693",
	"./custumer/shutterstock_387318658.png": "a4ec",
	"./custumer/sudan-1.png": "1973",
	"./custumer/sudan-2.png": "68e9",
	"./custumer/sudan-3.png": "63a6",
	"./custumer/zain-brand-2.png": "3a81",
	"./custumer/zain-brand.png": "1114",
	"./custumer/zain-businees.png": "ec13",
	"./diversity-inclusion/DandL.png": "e145",
	"./diversity-inclusion/Our-logo.png": "3738",
	"./diversity-inclusion/allTeam.png": "7735",
	"./diversity-inclusion/border_text.png": "0bd2",
	"./diversity-inclusion/eachforequal.png": "32ad",
	"./diversity-inclusion/main_background.png": "1744",
	"./diversity-inclusion/svg/vision-icon.svg": "ce8f",
	"./diversity-zain-team.png": "1506",
	"./drone/5g-drone.svg": "d03a",
	"./drone/SectionOnebg.png": "6f19",
	"./drone/certificate.svg": "315e",
	"./drone/drone-footer1.jpg": "0c8a",
	"./drone/drone-footer2.jpg": "9aa2",
	"./drone/drone-service.svg": "728a",
	"./drone/footer_shape.svg": "a374",
	"./drone/unlocking.svg": "8e58",
	"./drone/zainDrone-img1.png": "dc20",
	"./flags/bahrain.png": "fc5d",
	"./flags/iraq.png": "1b37",
	"./flags/jordan.png": "c8ae",
	"./flags/ksa.png": "d180",
	"./flags/kuwait.png": "ed6b",
	"./flags/morocco.png": "45a2f",
	"./flags/south-sudan.png": "96b2",
	"./flags/sudan.png": "9aad",
	"./gen-z-vs-pandemic.png": "acba",
	"./genz-20.png": "407a",
	"./governance/rule1.png": "1b11",
	"./graph-image-ar.png": "ce57",
	"./graph-image.png": "b60a",
	"./graph-image.svg": "9732",
	"./horizontal-line-mask.png": "c7f8",
	"./icon/New folder/next-arrow2.png": "42be",
	"./icon/arrow-double.png": "dae5",
	"./icon/arrow-double5.png": "8fd0",
	"./icon/arrow-down-green.png": "75da",
	"./icon/arrow-green-right.png": "da37",
	"./icon/arrow-green.png": "98e8",
	"./icon/arrow-long.png": "0a65",
	"./icon/arrow-yellow.png": "d2c9",
	"./icon/arrow.svg": "212a",
	"./icon/bg-icon.svg": "6038",
	"./icon/dellotie.svg": "840b",
	"./icon/dellotie1.svg": "d266",
	"./icon/digital-chart.png": "05cb",
	"./icon/digital-chart_ar.png": "5fbc",
	"./icon/icon1.svg": "45b7",
	"./icon/icon2.svg": "d89e",
	"./icon/icon3.svg": "344e",
	"./icon/icon4.svg": "99f1",
	"./icon/icon5.svg": "67b5",
	"./icon/icon6.svg": "1a455",
	"./icon/icon7.svg": "a65b",
	"./icon/icon8.svg": "e6b3",
	"./icon/prev-arrow.png": "887b",
	"./icon/rocket.svg": "9d70",
	"./icon/setting.svg": "44e8",
	"./icon/sound.svg": "9cf1",
	"./logos/colle capital.png": "2e94",
	"./logos/mevp.png": "59f3",
	"./logos/mevp11.png": "f8a0",
	"./logos/shlonik.png": "ae05",
	"./logos/streamingLogo.png": "0d98",
	"./logos/tamam.png": "1e77",
	"./logos/wamda.png": "c81e",
	"./logos/wasfa.png": "9042",
	"./logos/zain-cash.png": "6b1a",
	"./logos/zain-logo-black3.png": "34aa",
	"./logos/zain-logo-black4.png": "ac36",
	"./logos/zainLogo.png": "5de6",
	"./march_rules-ar.png": "ee8d",
	"./march_rules.png": "45a2",
	"./menu/BOD-msg.jpg": "c66e",
	"./menu/Comprehensive-Income.jpg": "7fc7",
	"./menu/Consolidated-Statement-of-Profit-or-Loss.jpg": "a682",
	"./menu/Financial-Position-.jpg": "43b9",
	"./menu/Independent-Auditor-Report.jpg": "ed13",
	"./menu/KPIs.jpg": "0460",
	"./menu/Remuneration_report.jpg": "73c0",
	"./menu/board-committee.jpg": "9383",
	"./menu/board_of_directors.jpg": "167e",
	"./menu/board_of_directors_governance.jpg": "98d7",
	"./menu/business_operation.jpg": "80d0",
	"./menu/cash-flows.jpg": "0a15",
	"./menu/code-of-conduct.jpg": "b552",
	"./menu/commercial.jpg": "90d9",
	"./menu/coroprate_sustainability.jpg": "7765",
	"./menu/disclosiure.jpg": "8b92",
	"./menu/diversity.jpg": "68e4",
	"./menu/executive_management.jpg": "e4f1",
	"./menu/financial-reporting.jpg": "7e6e",
	"./menu/galance.jpg": "35ec",
	"./menu/governance-BOD.jpg": "8712",
	"./menu/governance_introduction.jpg": "da36",
	"./menu/key_milestones.jpg": "9a05",
	"./menu/members_of_board.jpg": "77cf",
	"./menu/notes-to-financial-statements.jpg": "09bf",
	"./menu/performance-management.jpg": "a735",
	"./menu/regulatory.jpg": "64b1",
	"./menu/remutation_report.jpg": "fdea",
	"./menu/risk_management.jpg": "195b",
	"./menu/risk_management_and_internal.jpg": "4174",
	"./menu/shareholders_rights.jpg": "6c9f",
	"./menu/shareholders_rights1.jpg": "72b8",
	"./menu/stakeholders-rights.jpg": "9966",
	"./menu/strategy.jpg": "c20f",
	"./menu/sustainability.png": "3af8",
	"./menu/technology.jpg": "d489",
	"./menu/vice_chairman_and_ceo_statement.jpg": "8c21",
	"./menu/year_in_review.jpg": "d5e7",
	"./menu/year_in_review1.jpg": "8ec4",
	"./menu/zain-world.jpg": "8696",
	"./menu/zain_drone.jpg": "d06f",
	"./menuicon.png": "6b12",
	"./partners/1200px-Starzplay-logo.svg.png": "3b79",
	"./partners/CODASHOP-LOGO.png": "8f56",
	"./partners/apple.png": "1053",
	"./partners/being.png": "f14d",
	"./partners/centi.png": "beb5",
	"./partners/digital virgo.png": "c335",
	"./partners/docomodigital_logoSymbol.png": "12d8",
	"./partners/gamemine.png": "bbf6",
	"./partners/google.png": "fd38",
	"./partners/osn.png": "0bb6",
	"./partners/play vod.png": "a26e",
	"./partners/zain games.png": "7372",
	"./partners/zain kids.png": "f179",
	"./plane/plane.png": "0455",
	"./regulatory-icon/Group 125.svg": "ef5a",
	"./regulatory-icon/Group 133.svg": "c58a",
	"./regulatory-icon/Group 134.svg": "9da5",
	"./regulatory-icon/Group 135.svg": "53aa",
	"./regulatory-icon/Group 136.svg": "6402",
	"./regulatory-icon/Group 137.svg": "7535",
	"./regulatory-icon/Group 138.svg": "9eb8",
	"./regulatory-icon/Group 139.svg": "5036",
	"./regulatory-icon/Group 140.svg": "027b",
	"./risk-bg.jpg": "1d9b",
	"./riskmanagement-graph1-ar.png": "6241",
	"./riskmanagement-graph1.png": "24df",
	"./riskmanagement-graph2-ar.png": "b105",
	"./riskmanagement-graph2.png": "2ff4",
	"./section1-image2.png": "14d7",
	"./signature-ahmad.png": "0c0c",
	"./signature-bader.png": "29e9",
	"./signature.png": "4c2d",
	"./svg/Arabic_Chart.svg": "7884",
	"./svg/ChatDubble-ar.svg": "4d75",
	"./svg/ChatDubble.svg": "e7ae",
	"./svg/Group 1.svg": "706c",
	"./svg/UpdownArrow.png": "b6fe",
	"./svg/UpdownArrow.svg": "0b35",
	"./svg/africa-lg.svg": "ab05",
	"./svg/africa-stats.svg": "b2d4",
	"./svg/africa.svg": "f10d",
	"./svg/al-wazaan-signature.svg": "d700",
	"./svg/cardWorld.svg": "e0ce",
	"./svg/certificate.svg": "a007",
	"./svg/chart.svg": "1446",
	"./svg/chartCircle.svg": "f868",
	"./svg/chartImg.svg": "f335",
	"./svg/chart_ar.png": "90e2",
	"./svg/chart_ar.svg": "2ab2",
	"./svg/chatArrow.svg": "cc09",
	"./svg/circle.svg": "e8e5",
	"./svg/convergence.svg": "e12a",
	"./svg/country-morocco.svg": "1a75",
	"./svg/country-southsudan.svg": "1766",
	"./svg/country-sudan.svg": "b8ae",
	"./svg/cross.svg": "42db",
	"./svg/customer-stisfication.svg": "8096",
	"./svg/digital-chart - Copy.svg": "7971",
	"./svg/digital-chart.svg": "912a",
	"./svg/digital-chart_ar.svg": "3201",
	"./svg/digitization-arrow-icon.svg": "bf8d",
	"./svg/digitization-groth.svg": "2f56",
	"./svg/digitization-network.svg": "59d4",
	"./svg/digitization-population.svg": "3427",
	"./svg/digitization-total-trafic.svg": "4c22",
	"./svg/dollerImg.svg": "9693",
	"./svg/enterprise.svg": "d07f",
	"./svg/globe.svg": "24ec",
	"./svg/hand-drag.svg": "ec18",
	"./svg/handIcon.svg": "ffc6",
	"./svg/health.svg": "0035",
	"./svg/ict.svg": "39a4",
	"./svg/logo.svg": "a8bf",
	"./svg/mblIcon.svg": "c094",
	"./svg/menu.svg": "b28f",
	"./svg/menuicon.svg": "34bb",
	"./svg/meter.svg": "3a62",
	"./svg/middle-east-lg.svg": "8d8f",
	"./svg/middle-east-stats.svg": "7374",
	"./svg/middle-east.svg": "0f69",
	"./svg/minus.svg": "2595",
	"./svg/optimazation.svg": "35a5",
	"./svg/peoples.svg": "a2c1",
	"./svg/plus.svg": "0205",
	"./svg/right-arrow.svg": "66ba",
	"./svg/risk-management-graphic.svg": "17be",
	"./svg/search.svg": "2845",
	"./svg/signals.svg": "2436",
	"./svg/tech.svg": "486a",
	"./svg/threeUsers.svg": "18e7",
	"./svg/tik.svg": "3ce5",
	"./svg/tower.svg": "fb71",
	"./svg/towercus.svg": "5cc6",
	"./svg/vectorsHuman.svg": "7da7",
	"./svg/worldIcon.svg": "ee8f",
	"./svg/worldMap.svg": "c4cd",
	"./svg/year-digit.svg": "dce0",
	"./svg/year.svg": "3d7b",
	"./svg/zain-bahrain.svg": "f9f3",
	"./svg/zain-iraq.svg": "ad43",
	"./svg/zain-jordan.svg": "dcdb",
	"./svg/zain-ksa.svg": "ac6a",
	"./svg/zain-kuwait.svg": "fbaa",
	"./tribute/image1.png": "359e",
	"./tribute/image2.png": "f2d6",
	"./tribute/image3.png": "67b8",
	"./tribute/image4.png": "af2f",
	"./tribute/image5.png": "bda2",
	"./tribute/image6.png": "2c8d",
	"./vertical-line-mask.png": "0d55",
	"./vice-chairman/19.png": "2013",
	"./vice-chairman/19a.png": "1008",
	"./vice-chairman/Group 3.svg": "42e7",
	"./vice-chairman/tick.svg": "c139",
	"./video/home.mp4": "b219",
	"./year_in_review/apr/12.png": "94b1",
	"./year_in_review/apr/apr-2.jpg": "48d6",
	"./year_in_review/aug/24.png": "6eb2",
	"./year_in_review/aug/25-eng.png": "69d5",
	"./year_in_review/dec/33-dec.png": "8cd1",
	"./year_in_review/dec/34-dec.png": "d634",
	"./year_in_review/dec/35-dec.png": "f01b",
	"./year_in_review/dec/36-dec.png": "f467",
	"./year_in_review/dec/37-dec.png": "20f7",
	"./year_in_review/feb/6.png": "272a",
	"./year_in_review/feb/7.png": "93cb",
	"./year_in_review/image-1.png": "3b5a",
	"./year_in_review/image-2.png": "131e",
	"./year_in_review/image-3.png": "c58c",
	"./year_in_review/intro/ok.svg": "f591",
	"./year_in_review/jan/2.png": "ac44",
	"./year_in_review/jan/jan-1.jpg": "5280",
	"./year_in_review/jan/jan-2.png": "090d",
	"./year_in_review/jan/jan-4.jpg": "50a5",
	"./year_in_review/jan/jan-5.jpg": "7b06",
	"./year_in_review/jul/21-eng.png": "9992",
	"./year_in_review/jul/2_1.png": "b752",
	"./year_in_review/jul/july-3.jpg": "34ac",
	"./year_in_review/jul/july-4.jpg": "368d",
	"./year_in_review/jun/17-eng.png": "09a2",
	"./year_in_review/jun/5g-1.png": "8911",
	"./year_in_review/jun/June--Hedera-Logo.png": "d3a4",
	"./year_in_review/mar/march-1.jpg": "2279",
	"./year_in_review/mar/march-2.jpg": "0a3f",
	"./year_in_review/mar/march-3.jpg": "3df2",
	"./year_in_review/mar/march-4.png": "610b",
	"./year_in_review/may/15-eng.png": "3786",
	"./year_in_review/may/may-3.jpg": "1fb5",
	"./year_in_review/may/zain_ramadan_tvc_2020-1.png": "e3f8",
	"./year_in_review/nov/28.png": "63af",
	"./year_in_review/nov/31.png": "8ba2",
	"./year_in_review/nov/Nov5G.png": "e21b",
	"./year_in_review/oct/28.png": "5c2f",
	"./year_in_review/oct/OTC-forbes_logo.png": "7230",
	"./year_in_review/sep/Nov5G.png": "66ae",
	"./year_in_review/sep/sep-2.jpg": "8a0e",
	"./zain-logo-black.png": "97b9",
	"./zain-logo-black2.png": "2838",
	"./zain-logo-black3.png": "1253",
	"./zain-logo-black4.png": "cf73",
	"./zain-logo.png": "a70b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";